import React from 'react';

import { CaptionProps, RateProps, TextareaProps, Typography } from 'fronton-react';
import { styled } from 'linaria/react';
import { jcm } from 'utils';
import {
  scoreFieldLayout,
  scoreFieldLayoutColumn,
  scoreFieldCaption,
  scoreDetailFieldCaption,
  scoreFieldCaptionAtColumn,
  textareaField,
  textareaFieldStatus,
  textareaFieldCaption,
  textareaFieldCounters,
} from '../styles';
import { REVIEW_FORM_MAX_TEXT_LENGTH } from 'common/constants';

export const FormPart = styled.div`
  margin-bottom: 48px;
`;

export const UsageFormPart = styled.div`
  margin-bottom: var(--space-500);
`;

export const RatingFormPart = styled.div`
  margin-bottom: var(--space-750);
  @media (--only-mobile) {
    margin-bottom: var(--space-600);
  }
`;

export const ScoreField: React.FC<
  {
    asColumn: boolean;
    isDetailScore?: boolean;
    scoreControl: React.ReactElement<RateProps>;
    captionView?: React.ReactElement<CaptionProps>;
  } & React.HTMLAttributes<HTMLElement>
> = ({ asColumn, isDetailScore = false, scoreControl, captionView, className = '', ...htmlProps }) => (
  <div
    className={jcm({
      [className]: true,
      [scoreFieldLayout]: true,
      [scoreFieldLayoutColumn]: asColumn,
    })}
    {...htmlProps}
  >
    <div>{scoreControl}</div>
    {captionView !== undefined && (
      <div
        className={jcm({
          [scoreFieldCaption]: true,
          [scoreDetailFieldCaption]: isDetailScore,
          [scoreFieldCaptionAtColumn]: asColumn,
        })}
      >
        {captionView}
      </div>
    )}
  </div>
);

export const TextareaField: React.FC<{
  textarea: React.ReactElement<TextareaProps>;
  errorCaption: React.ReactElement<CaptionProps> | null;
  textLength: number;
  dataQa?: string;
}> = ({ textarea, errorCaption, textLength, dataQa }) => (
  <div className={textareaField} data-qa={dataQa}>
    <div>{textarea}</div>
    <div className={textareaFieldStatus}>
      <div className={textareaFieldCaption}>{errorCaption}</div>
      <div className={textareaFieldCounters}>
        <Typography variant="caption" color="text-minor">
          {textLength} / {REVIEW_FORM_MAX_TEXT_LENGTH}
        </Typography>
      </div>
    </div>
  </div>
);
